import type { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type {
    ImageChooserBlock,
    OprahBlock as OprahBlockValue,
} from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

const imageFileSrc = (
    image: Immutable<ImageChooserBlock> | null | undefined,
): string => image?.imageData ?? image?.url ?? "";

export const HomeOprahBlock = (
    props: Immutable<{
        value: OprahBlockValue;
        chillUrl: string;
        classicUrl: string;
    }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.oprahModuleHome,
            "stitch-bg--light",
        ])}
    >
        <div className="main-container">
            <div className={styles.oprahModuleHomeInfo}>
                <div className={styles.oprahModuleHomeCopy}>
                    <span className={styles.oprahModuleHomeQuotes}>
                        &ldquo;
                    </span>
                    {t`If there’s anything better than a good night’s sleep, let me know, because I haven’t found it. What I have found is a memory-foam mattress that ships in a remarkably hassle-free box that will actually fit through your door. Open it up and hit the hay.”`}
                </div>
                <div
                    className={styles.oprahModuleHomeAttribution}
                >{t`- Oprah`}</div>
                <div className={styles.oprahModuleHomeLinks}>
                    <div className={styles.oprahModuleHomeLink}>
                        <a
                            className={concatClassNames([
                                styles.oprahModuleHomeLinkButton,
                                "button",
                            ])}
                            href={props.chillUrl}
                        >
                            Shop Chill
                        </a>
                        <div className={styles.oprahModuleHomeLinkPricing}>
                            {t`Starting at $549`}
                        </div>
                    </div>
                    <div className={styles.oprahModuleHomeLink}>
                        <a
                            className={concatClassNames([
                                styles.oprahModuleHomeLinkButton,
                                "button",
                            ])}
                            href={props.classicUrl}
                        >
                            Shop Classic
                        </a>
                        <div className={styles.oprahModuleHomeLinkPricing}>
                            {t`Starting at $399`}
                        </div>
                    </div>
                </div>
            </div>
            <img
                src={imageFileSrc(props.value.image)}
                alt="Shop Cocoon by Sealy"
                className={concatClassNames([
                    styles.oprahModuleHomeImage,
                    "responsive",
                ])}
                loading="lazy"
                decoding="async"
            />
        </div>
    </section>
);
